import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {ShowcaseConfigurationBox} from "../boxes/showcase-configuration/showcase-configuration.box";
import {ShowcaseContentContainerBox} from "../boxes/showcase-content-container/showcase-content-container.box";
import {BurnoutAnimationShowcase} from "./pixi-animations-showcases/burnout-animation-showcase.component";
import {Magic8BallShowcase} from "./pixi-animations-showcases/magic-8-ball-showcase.component";
import {PixiSpineShowcase} from "./pixi-animations-showcases/pixi-spine-showcase.component";

export class PixiAnimationsShowcase extends OrbitComponent {
    render() {
        return (<>
            <ShowcaseContentContainerBox>
                <ShowcaseConfigurationBox>
                    <BurnoutAnimationShowcase />
                </ShowcaseConfigurationBox>
                <ShowcaseConfigurationBox>
                    <Magic8BallShowcase />
                </ShowcaseConfigurationBox>
            </ShowcaseContentContainerBox>
            <ShowcaseContentContainerBox>
                <ShowcaseConfigurationBox>
                    <PixiSpineShowcase />
                </ShowcaseConfigurationBox>
            </ShowcaseContentContainerBox>
        </>);
    }
    
}